import { render } from "./LuxWidget.vue?vue&type=template&id=f7b148c0&scoped=true&ts=true"
import script from "./LuxWidget.vue?vue&type=script&lang=ts"
export * from "./LuxWidget.vue?vue&type=script&lang=ts"

import "./LuxWidget.vue?vue&type=style&index=0&id=f7b148c0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7b148c0"]])

export default __exports__